import { useId } from 'react';

// Stand-in for Figma "Drills" — replace with the design export when it lands.
export default function GameTypeDrill({ className }: { className?: string }) {
  const id = `game-type-drill-${useId().replace(/:/g, '')}`;

  return (
    <svg className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3.1" y="9" width="13.8" height="2" rx="1" fill={`url(#${id}-bar)`} />
      <rect x="5.1" y="6.3" width="2.6" height="7.4" rx="1.1" fill={`url(#${id}-plate)`} />
      <rect x="12.3" y="6.3" width="2.6" height="7.4" rx="1.1" fill={`url(#${id}-plate)`} />
      <rect x="1.9" y="7.7" width="1.9" height="4.6" rx="0.95" fill={`url(#${id}-collar)`} />
      <rect x="16.2" y="7.7" width="1.9" height="4.6" rx="0.95" fill={`url(#${id}-collar)`} />
      <rect x="5.1" y="6.3" width="2.6" height="7.4" rx="1.1" fill={`url(#${id}-sheen)`} />
      <rect x="12.3" y="6.3" width="2.6" height="7.4" rx="1.1" fill={`url(#${id}-sheen)`} />
      <defs>
        <linearGradient
          id={`${id}-bar`}
          x1="3.1"
          y1="9"
          x2="3.1"
          y2="11"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD45E" />
          <stop offset="1" stopColor="#E09A22" />
        </linearGradient>
        <linearGradient
          id={`${id}-plate`}
          x1="6.4"
          y1="6.3"
          x2="6.4"
          y2="13.7"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC940" />
          <stop offset="0.56" stopColor="#F9A417" />
          <stop offset="1" stopColor="#D27A14" />
        </linearGradient>
        <linearGradient
          id={`${id}-collar`}
          x1="2.85"
          y1="7.7"
          x2="2.85"
          y2="12.3"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFDE7B" />
          <stop offset="1" stopColor="#E8A62A" />
        </linearGradient>
        <radialGradient
          id={`${id}-sheen`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(6.1 7.6) rotate(68) scale(5.2 2.1)"
        >
          <stop stopColor="#FFF0A8" stopOpacity="0.85" />
          <stop offset="1" stopColor="#FFF0A8" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  );
}
